import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dCoreSites$dTranslations$dKeys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAllergen from "../Restaumatic.Menu.V2.Types.Allergen/index.js";
const translatedAllergen = v => {
  if (v.tag === "Gluten") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Gluten), {});
  }
  if (v.tag === "Crustaceans") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Crustaceans), {});
  }
  if (v.tag === "Eggs") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Eggs), {});
  }
  if (v.tag === "Fish") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Fish), {});
  }
  if (v.tag === "Peanuts") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Peanuts), {});
  }
  if (v.tag === "Soybeans") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Soybeans), {});
  }
  if (v.tag === "Milk") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Milk), {});
  }
  if (v.tag === "Nuts") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Nuts), {});
  }
  if (v.tag === "Celery") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Celery), {});
  }
  if (v.tag === "Mustard") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Mustard), {});
  }
  if (v.tag === "Sesame") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Sesame), {});
  }
  if (v.tag === "SulphurDioxide") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.SulphurDioxide), {});
  }
  if (v.tag === "Lupin") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Lupin), {});
  }
  if (v.tag === "Molluscs") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Molluscs), {});
  }
  $runtime.fail();
};
const productKeyAllergens = catalogue => productKey => {
  const modifierValuesAllergens = modifierValues => Data$dFoldable.foldableArray.foldMap({
    mempty: Data$dMap$dInternal.Leaf,
    Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)})
  })(v => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v._1)(Data$dRecord.unsafeGet("modifiers")(catalogue));
    const itemMap = (() => {
      if ($0.tag === "Nothing") { return Data$dMap$dOrdered.$OMap(Data$dMap$dInternal.Leaf, []); }
      if ($0.tag === "Just") { return Restaumatic$dMenu$dV2$dMenuCatalogue.modifierItems($0._1); }
      $runtime.fail();
    })();
    return Data$dFoldable.foldableArray.foldMap({
      mempty: Data$dMap$dInternal.Leaf,
      Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)})
    })(itemId => {
      const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(itemId)(itemMap._1);
      if ($1.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
      if ($1.tag === "Just") { return Data$dMap$dInternal.functorMap.map(v$1 => {})(Data$dRecord.unsafeGet("allergens")($1._1)); }
      $runtime.fail();
    })(Data$dMultiSet.distinctElems(v._2));
  })(Data$dMap$dInternal.toUnfoldableUnordered(Data$dUnfoldable.unfoldableArray)(modifierValues));
  return Data$dMap$dInternal.unionWith(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)(Data$dFunction.const)(modifierValuesAllergens(Data$dRecord.unsafeGet("modifiers")(productKey)))(Data$dFoldable.foldableArray.foldMap({
    mempty: Data$dMap$dInternal.Leaf,
    Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)})
  })(part => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(Data$dRecord.unsafeGet("productId")(part))(Data$dRecord.unsafeGet("products")(catalogue));
    return Data$dMap$dInternal.unionWith(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)(Data$dFunction.const)(modifierValuesAllergens(Data$dRecord.unsafeGet("modifiers")(part)))((() => {
      if ($0.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
      if ($0.tag === "Just") { return Data$dMap$dInternal.functorMap.map(v => {})(Data$dRecord.unsafeGet("allergens")($0._1)); }
      $runtime.fail();
    })());
  })(Data$dRecord.unsafeGet("parts")(productKey)));
};
export {productKeyAllergens, translatedAllergen};
